import { render } from "./curb.vue?vue&type=template&id=b912e7c0&ts=true"
import script from "./curb.vue?vue&type=script&lang=ts"
export * from "./curb.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__